import React from 'react'
import type { FC } from 'react'
import { Portal, Typography, useMediaQuery, useTheme } from '@mui/material'
import { ICON_SIZE } from '../Icon/constants'
import { CLOSE_SNACKBAR_TIME_MS } from './constants'
import { Body, Description, LeftContent, StyledSnackbar, TitleRow } from './styles'
import type { SnackbarBaseProps } from './types'
import VariantIcon from './variant-icons'

const SnackbarBase: FC<SnackbarBaseProps> = ({
  open,
  icon,
  title,
  description,
  variant,
  onClose,
  action,
  autoHideDuration = CLOSE_SNACKBAR_TIME_MS,
  ...rest
}) => {
  const { palette, breakpoints } = useTheme()
  const isSmallScreen = useMediaQuery(breakpoints.down('sm'))
  const hasDescription = Boolean(description)

  return (
    <Portal>
      <StyledSnackbar
        {...rest}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={autoHideDuration}
        open={open}
        variant={variant}
        backgroundColor={palette.grey[700]}
        onClose={onClose}
        isSmallScreen={isSmallScreen}
      >
        <Body>
          <TitleRow>
            <LeftContent>
              {Boolean(variant) && <VariantIcon size={ICON_SIZE.medium} icon={icon} variant={variant} isFilled />}
              <Typography variant="body2" color={palette.textLight.primary}>
                {title}
              </Typography>
            </LeftContent>
            {action}
          </TitleRow>
          {hasDescription && (
            <Description variant="caption" color={palette.textLight.secondary}>
              {description}
            </Description>
          )}
        </Body>
      </StyledSnackbar>
    </Portal>
  )
}

export default SnackbarBase
